import React, { ChangeEvent, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { addCartItem } from '../../redux/reducers/cartReducer'
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs'
import Button from '../Button/Button'

import './ProductContent.scss'

const ProductContent = (props: {productId: string}) => {
    const products = useAppSelector((state) => state.productReducer)
    const product = products.find(item => item.id === parseInt(props.productId))
    const cart = useAppSelector((state) => state.cartReducer)
    const cartProduct = !!product ? cart.find(item => item.id === product.id) : undefined
    const dispatch = useAppDispatch()
    const [count, setCount] = useState(1)
  return (
    <div className="product">
        {product ? 
        (<section className='paddingless'>
            <div className="product-panel">
                <div className="container">
                    <div className="product-panel-item">
                        <span className='product-price'>On sale from: <span className='bold'>${product.price}</span></span>
                        <input type="number" min={1} disabled={!!cartProduct} value={cartProduct?.count || count} onChange={(e: ChangeEvent<HTMLInputElement>) => setCount(parseInt(e.target.value))}/>
                    </div>
                    <div className="product-panel-item">
                        <Button action={()=>{
                            !!cartProduct ? console.log() : dispatch(addCartItem({
                                id: product.id,
                                product,
                                count
                            }))
                        }} variant={cartProduct ? 'disabled' : 'filled'}>Add To Cart</Button>
                    </div>
                </div>
            </div>
            <div className="product-page">
                <div className="product-info">
                    <Breadcrumbs/> 
                    <h1>{product.title}</h1>
                    <p className='product-info-description'>{product.description}</p>
                    <div className="product-info-additional">
                        <p className="product-info-additional__question">Have a question? <Link to="/contact">Contact Us</Link></p>
                        <p className="product-info-additional__article">Article: {product.id}</p>
                    </div>
                </div>
                <div className="product-image">
                    <div className="image">
                        <img src={product.images[0]} alt="" />
                    </div>
                </div>
            </div>
        </section>)
     : <div className="container">
        <span className="product-item-error">Product was not found</span>
     </div>}
    </div>
  )
}

export default ProductContent